import React, { useEffect, useMemo, useState } from "react";
import {
  Route,
  Switch,
  Router,
  Link,
  Redirect,
  useLocation,
  useHistory,
  useParams,
  useRouteMatch,
} from "react-router-dom";
import { imagePath } from "../../assets/ImagePath";
// import SettingDetails from "../../components/Settings/SettingDetails";

const Header = React.lazy(() => import("../.././components/Header"));
const Footer = React.lazy(() => import("../.././components/Footer"));
const SideNav = React.lazy(() => import("../.././components/SideNav"));
const Home = React.lazy(() => import("../.././components/Home"));
const Users = React.lazy(() => import("../.././components/Users"));
const ApiKeys = React.lazy(() => import("../.././components/ApiKeys"));
const BusinessProfile = React.lazy(() =>
  import("../.././components/BusinessProfile")
);
const SettingDetails = React.lazy(() =>
  import("../../components/Settings/SettingDetails")
);
const Payouts = React.lazy(() => import("../.././components/Payouts"));
const AccountStatement = React.lazy(() =>
  import("../.././components/AccountStatement")
);
const Contacts = React.lazy(() => import("../.././components/Contacts"));
const Accounts = React.lazy(() => import("../.././components/Accounts"));
const UserRole = React.lazy(() => import("../../components/UserRole"));
const AddUsers = React.lazy(() => import("../../components/AddUser"));
const EditUsers = React.lazy(() => import("../../components/EditUser"));
const Prefix = React.lazy(() => import("../../components/Prefix"));
const BulkUpload = React.lazy(() => import("../../components/BulkUpload"));
const PayoutLinks = React.lazy(() => import("../../components/PayoutLinks"));
const SchedulePayments = React.lazy(() =>
  import("../../components/ScheduledPayments")
);
const ViewBankList = React.lazy(() =>
  import("../../components/ConnectedBanking/ViewBankList")
);
const DownloadManager = React.lazy(() =>
  import("../../components/DownloadManager")
);
const GenerateReport = React.lazy(() =>
  import("../../components/DownloadManager/GenerateReport")
);

const BulkQueueList = React.lazy(() =>
  import("../../components/BulkUploadQueue/BulkQueueList")
);
const MakerChecker = React.lazy(() => import("../../components/MakerChecker"));
const MakerCheckerDetails = React.lazy(() =>
  import("../../components/MakerCheckerDetails")
);

const ViewWhiteListBeneficiary = React.lazy(() =>
  import("../../components/Beneficiary")
);
// const Invoice = React.lazy(() => import('../../components/Invoice/index.js'));
// const ViewInvoice = React.lazy(() => import('../../components/Invoice/ViewInvoice'));
function MainApp() {
  const location = useLocation();

  return (
    <React.Suspense
      fallback={
        <div id="loading_img">
          <div id="img_loading_mask"></div>
          <div className="content_loading_img">
            <img src={imagePath("./bgloader.svg").default} width="100" />
          </div>
        </div>
      }
    >
      <Header />
      <div className="container container-custom">
        <SideNav />
        <Switch location={location}>
          <Route exact={true} path="/dashboard" component={Home} />
          <Route exact={true} path="/users" component={Users} />
          <Route exact={true} path="/role" component={UserRole} />
          <Route exact={true} path="/api" component={ApiKeys} />
          <Route
            exact={true}
            path="/businessprofile"
            component={BusinessProfile}
          />
          <Route exact={true} path="/settings" component={SettingDetails} />
          <Route exact={true} path="/payouts" component={Payouts} />
          <Route
            exact={true}
            path="/transaction"
            component={AccountStatement}
          />
          <Route
            exact
            path="/transaction"
            render={(props) => (
              <AccountStatement key={location.pathname} {...props} />
            )}
          />
          <Route
            exact
            path="/transaction/:id"
            render={(props) => (
              <AccountStatement key={location.pathname} {...props} />
            )}
          />
          <Route
            exact
            path="/transaction/list/:trans_ref_id"
            render={(props) => (
              <AccountStatement key={location.pathname} {...props} />
            )}
          />
          <Route
            exact
            path="/transaction/ref/:trans_ref"
            render={(props) => (
              <AccountStatement key={location.pathname} {...props} />
            )}
          />
          <Route
            exact
            path="/transaction/subaccount/:virt_acc_num"
            render={(props) => (
              <AccountStatement key={location.pathname} {...props} />
            )}
          />
          <Route exact={true} path="/contacts" component={Contacts} />
          <Route
            exact={true}
            path="/contacts/view-beneficiarys"
            component={ViewWhiteListBeneficiary}
          />
          <Route exact={true} path="/accounts" component={Accounts} />
          <Route exact={true} path="/adduser" component={AddUsers} />
          <Route exact={true} path="/edituser/:id" component={EditUsers} />
          <Route exact={true} path="/prefix" component={Prefix} />
          <Route exact={true} path="/bulkupload" component={BulkUpload} />
          <Route exact={true} path="/payoutlink" component={PayoutLinks} />
          <Route exact={true} path="/bank-list" component={ViewBankList} />
          <Route
            exact={true}
            path="/schedule-payment"
            component={SchedulePayments}
          />
          <Route exact={true} path="/report-list" component={DownloadManager} />
          <Route
            exact={true}
            path="/report-list/generate-reports/:id"
            component={GenerateReport}
          />
          <Route
            exact={true}
            path="/bulk-upload/bulk-upolad-queue-list/:batchId"
            component={BulkQueueList}
          />
          {/* <Route exact={true} path="/bulk-upload/bulk-upolad-queue-list/:batchId" component={GenerateReport}/> */}

          {/*    <Route exact={true} path="/invoice" component={Invoice}/>
          <Route exact={true} path="/view-invoice" component={ViewInvoice}/> */}
          <Route exact={true} path="/payout-request" component={MakerChecker} />
          <Route
            exact={true}
            path="/payout-request/details/:id"
            component={MakerCheckerDetails}
          />
          <Route path="/*" render={() => <Redirect to="/dashboard" />} />
        </Switch>
      </div>
      <Footer />
    </React.Suspense>
  );
}

export default MainApp;
